module.exports = "/packs/she_chan_comment-aa994ffd84305f5f92e78cc6c7d1063a.svg";